"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

var _defaultsDeep2 = _interopRequireDefault(require("lodash/defaultsDeep"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tracking = require("@nerdwallet/nw-client-lib/tracking");

var _impression = require("@nerdwallet/analytics/react/impression");

var _arrows = require("./arrows");

var _utils = _interopRequireDefault(require("./utils"));

require("./carousel.less");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);

  var _super = _createSuper(Carousel);

  function Carousel() {
    var _this;

    _classCallCheck(this, Carousel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "DEFAULT_SETTINGS", {
      appendDots: _this.appendDots.bind(_assertThisInitialized(_this)),
      arrows: true,
      infinite: false,
      nextArrow: /*#__PURE__*/_react["default"].createElement(_arrows.ArrowNext, _extends({}, _this.props, {
        impression: _this.context
      })),
      onSwipe: _this.onSwipe.bind(_assertThisInitialized(_this)),
      prevArrow: /*#__PURE__*/_react["default"].createElement(_arrows.ArrowPrev, _extends({}, _this.props, {
        impression: _this.context
      })),
      swipeToSlide: true
    });

    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('touchstart', this.touchStart);
      window.addEventListener('touchmove', this.preventTouch, {
        passive: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('touchstart', this.touchStart);
      window.removeEventListener('touchmove', this.preventTouch, {
        passive: false
      });
    }
  }, {
    key: "onSwipe",
    value: function onSwipe(direction) {
      var id = this.props.id;
      var impression = this.context;
      (0, _utils["default"])(id, impression, 'swipe');
      (0, _tracking.elementInteraction)({
        elementName: "carousel__body--".concat(id),
        interactionType: 'SWIPE',
        sectionCategory: 'carousel',
        elementCategory: 'body',
        elementDomType: 'div',
        elementContent: direction
      }); // Had to reach into the <InnerSlider> component to update
      // this internal variable to true, this is  known bug with react slick
      // see: https://github.com/akiran/react-slick/issues/604#issuecomment-400350967

      if (this.slider) {
        this.slider.innerSlider.clickable = true;
      }
    }
  }, {
    key: "touchStart",
    value: function touchStart(e) {
      this.firstClientX = e.touches[0].clientX;
      this.firstClientY = e.touches[0].clientY;
    } // This only disables vertical scrolling if you are in the middle of a horizontal scroll in the carousel.
    // If a horizontal scroll in the carousel has not been initiated then normal vertical scrolling is not restricted.
    // Prevent only happens if the scroll happens above a threshold of 5.

  }, {
    key: "preventTouch",
    value: function preventTouch(e) {
      // Threshold value that scroll behavior has to exceed to prevent vertical scroll
      var minValue = 5;
      this.clientX = e.touches[0].clientX - this.firstClientX;
      this.clientY = e.touches[0].clientY - this.firstClientY; // Prevent vertical scrolling when horizontally scrolling in carousel.

      if (Math.abs(this.clientX) > minValue) {
        e.preventDefault();
        e.stopPropagation();
      }

      return true;
    }
  }, {
    key: "appendDots",
    value: function appendDots(dots) {
      var _this2 = this;

      var _onClick = function onClick(e, options) {
        var id = _this2.props.id;
        var impression = _this2.context;
        (0, _utils["default"])(id, impression, 'press');
        (0, _tracking.elementInteraction)({
          elementName: "carousel__nav-dots--".concat(id),
          interactionType: 'CLICK',
          sectionCategory: 'carousel',
          elementCategory: 'nav-dots',
          elementDomType: 'button',
          elementPosition: options.elementPosition
        });

        if (options.onClick) {
          options.onClick(e);
        }
      };

      return /*#__PURE__*/_react["default"].createElement("ul", null, _react["default"].Children.map(dots, function (dot, index) {
        return /*#__PURE__*/_react["default"].cloneElement(dot, {
          onClick: function onClick(event) {
            return _onClick(event, {
              elementPosition: index
            });
          }
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          classname = _this$props.classname,
          children = _this$props.children;
      var settings = (0, _defaultsDeep2["default"])({}, this.props, this.DEFAULT_SETTINGS);

      var sliderRef = function sliderRef(slider) {
        _this3.slider = slider;
      };

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(['carousel', settings.dots && 'has-dots', classname])
      }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({}, settings, {
        ref: sliderRef
      }), children));
    }
  }]);

  return Carousel;
}(_react.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


_defineProperty(Carousel, "contextType", _impression.ImpressionContext);

Carousel.propTypes = _objectSpread(_objectSpread({}, _reactSlick["default"].propTypes), {}, {
  /** ID used for tracking purposes. */
  id: _propTypes["default"].string.isRequired,

  /** Classes applied to the carousel. */
  className: _propTypes["default"].string,

  /** Slides to display in the carousel. */
  children: _propTypes["default"].arrayOf(_propTypes["default"].node)
});
var _default = Carousel;
exports["default"] = _default;